import { createReducer } from '@reduxjs/toolkit'
import { createBuilder } from 'packages/redux-toolkit'

import { setDrawerIsOpen } from './actions'

interface UIState {
  drawer: {
    isOpen: boolean
  }
}

const initialState: UIState = {
  drawer: {
    isOpen: true,
  },
}

export const uiReducer = createReducer(initialState, (builder) => {
  createBuilder(builder).addCase(setDrawerIsOpen, (state, { payload }) => {
    state.drawer.isOpen = payload
  })
})
